var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('simulation-form-wrapper',{attrs:{"loading":_vm.store.loading,"simulation":_vm.store.simulation,"simulation-demand":_vm.store.userInput},scopedSlots:_vm._u([{key:"form",fn:function({isFormValid}){return [_c('router-view',{attrs:{"simulationDemand":_vm.store.userInput,"isFormValid":isFormValid}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }